import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { WEDDING_CONFIG } from '../config';

const LandingPage = () => {
  const navigate = useNavigate();
  const [fadeIn, setFadeIn] = useState(false);

  useEffect(() => {
    setFadeIn(true);
  }, []);

  const handleEnter = () => {
    navigate('/home');
  };

  return (
    <div style={styles.landing}>
      <div style={styles.overlay}></div>
      <div style={{...styles.content, opacity: fadeIn ? 1 : 0}}>
        <h2 style={styles.subtitle}>THE WEDDING OF</h2>
        <h1 style={styles.title}>
          {WEDDING_CONFIG.bride} <span style={styles.ampersand}>&</span> {WEDDING_CONFIG.groom}
        </h1>
        <button 
          style={styles.enterButton} 
          onClick={handleEnter}
          onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'}
          onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
        >
          Open Invitation
        </button>
        <p style={styles.hashtag}>#{WEDDING_CONFIG.hashtag}</p>
      </div>

    </div>
  );
};

const styles = {
  landing: {
    height: '100vh',
    width: '100vw',
    background: `linear-gradient(135deg, ${WEDDING_CONFIG.colors.primary}40, ${WEDDING_CONFIG.colors.secondary}40), url('/images/landing-bg.jpg')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    overflow: 'hidden',
  },
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: `linear-gradient(135deg, ${WEDDING_CONFIG.colors.primary}20, ${WEDDING_CONFIG.colors.secondary}30)`,
    backdropFilter: 'blur(2px)',
  },
  content: {
    position: 'relative',
    zIndex: 2,
    textAlign: 'center',
    color: 'white',
    padding: '2rem',
    maxWidth: '800px',
    transition: 'opacity 1s ease-in',
  },
  divider: {
    fontSize: '2rem',
    margin: '1rem 0',
    color: WEDDING_CONFIG.colors.accent1,
  },
  subtitle: {
    fontSize: '2rem',
    letterSpacing: '4px',
    fontWeight: '300',
    marginBottom: '1rem',
    opacity: 0.9,
  },
  title: {
    fontSize: '6rem',
    fontWeight: '700',
    margin: '1rem 0',
    fontFamily: "'Playfair Display', serif",
    textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
  },
  ampersand: {
    fontSize: '3.5rem',
    fontStyle: 'italic',
    color: WEDDING_CONFIG.colors.accent1,
    margin: '0 1rem',
  },
  date: {
    fontSize: '2rem',
    fontWeight: '300',
    margin: '1rem 0 2rem 0',
    letterSpacing: '2px',
  },
  enterButton: {
    marginTop: '2rem',
    padding: '1rem 3rem',
    fontSize: '1.1rem',
    fontWeight: '600',
    color: WEDDING_CONFIG.colors.primary,
    background: 'white',
    border: 'none',
    borderRadius: '50px',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
  },
  hashtag: {
    marginTop: '2rem',
    fontSize: '1rem',
    letterSpacing: '2px',
    opacity: 0.8,
    fontStyle: 'italic',
  }
};

export default LandingPage;